import { CalendarDays } from 'lucide-react';
import { Button } from '../../ui/button';
import { Calendar } from '../../ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';
import { addDays, endOfDay } from '../qualityConfig';

const QUICK = [{ label: '+3 days', days: 3 }, { label: '1 week', days: 7 }, { label: '2 weeks', days: 14 }, { label: '1 month', days: 30 }];

const sameDay = (a, b) => Boolean(a && b) && a.toDateString() === b.toDateString();

export const DeadlinePicker = ({ value, onChange, base, testId = 'task-deadline-picker' }) => {
    const from = base || new Date();
    return (
        <div className="space-y-2" data-testid={testId}>
            <div className="flex flex-wrap gap-1.5">
                {QUICK.map((q) => {
                    const date = endOfDay(addDays(from, q.days));
                    return (
                        <button
                            key={q.days}
                            type="button"
                            onClick={() => onChange(date)}
                            className={`rounded-full border px-3 py-1 text-xs font-medium transition-colors ${sameDay(value, date)
                                ? 'border-violet-500 bg-violet-500/10 text-violet-700 dark:text-violet-300' : 'hover:bg-muted'}`}
                            data-testid={`${testId}-quick-${q.days}`}
                        >
                            {q.label}
                        </button>
                    );
                })}
            </div>
            <Popover>
                <PopoverTrigger asChild>
                    <Button variant="outline" className="w-full justify-start font-normal" data-testid={`${testId}-trigger`}>
                        <CalendarDays className="mr-2 h-4 w-4 text-violet-500" />
                        {value ? value.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' }) : 'Pick a date'}
                    </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0" align="start">
                    <Calendar mode="single" selected={value} onSelect={(d) => d && onChange(endOfDay(d))} disabled={(d) => endOfDay(d) <= from} initialFocus />
                </PopoverContent>
            </Popover>
            <p className="text-xs text-muted-foreground">Due at the end of the selected day. After that the task locks and scores 0.</p>
        </div>
    );
};
